export const player1Color = "#ff2647";
export const player2Color = "#42eff5";

export const PLAYER_1_DEPLOYMENT = 6;
export const PLAYER_2_DEPLOYMENT = 11;

export const SCENARIO_OPTIONS = [
  {
    label: "1 Trench Warfare",
    value: "trenchWarfare",
  },
  {
    label: "2 Two Fronts",
    value: "twoFronts",
  },
  {
    label: "3 Wolves At Our Heels",
    value: "wolvesAtOurHeels",
  },
  {
    label: "4 Pressure Point",
    value: "pressurePoint",
  },
  {
    label: "5 High Stakes",
    value: "highStakes",
  },
  {
    label: "6 Fault Line",
    value: "faultLine",
  },
  {
    label: "7 Payload",
    value: "payload",
  },
];

export const OBJECTIVES = {
  ["40"]: {
    label: "40",
    zone: 3,
  },
  ["50"]: {
    label: "50",
    zone: 3,
  },
  ["flag"]: {
    label: "flag",
    zone: 5,
  },
  ["cache"]: {
    label: "cache",
    zone: 3,
  },
};

export const SCENARIOS = {
  trenchWarfare: {
    rules: [
      `- 0 Victory Points scored by own Flag`,
      `- 2 Victory Points scored by opponents Flag`,
      `- When within 3" of a player's own 40mm or 50mm objective, medium and small based warriors models gain cover and resistance blast.`,
    ],
    objectives: [
      {
        type: "flag",
        player: 1,
        bottom: 17,
        left: 6,
      },
      {
        type: "40",
        player: 1,
        right: 22,
        bottom: 14,
      },
      {
        type: "cache",
        player: 1,
        bottom: 22,
        right: 20,
      },
      {
        type: "50",
        player: 1,
        bottom: 25,
        right: 12,
      },
      {
        type: "flag",
        player: 2,
        bottom: 15,
        left: 6,
      },
      {
        type: "40",
        player: 2,
        right: 22,
        bottom: 12,
      },
      {
        type: "cache",
        player: 2,
        bottom: 18,
        right: 20,
      },
      {
        type: "50",
        player: 2,
        bottom: 21,
        right: 12,
      },
    ],
  },

  twoFronts: {
    rules: [
      `A player that secures both 40mm Objectives, scores an additional victory point at the end of each turn.`,
      `A player that secures both 50mm Objectives, scores an additional victory point at the end of each turn.`,
    ],
    objectives: [
      {
        type: "40",
        player: 1,
        left: 8,
        bottom: 20,
      },
      {
        type: "50",
        player: 1,
        right: 8,
        bottom: 19,
      },
      {
        type: "50",
        player: 2,
        left: 12,
        bottom: 17,
      },
      {
        type: "flag",
        player: 2,
        right: 23,
        bottom: 24,
      },
      {
        type: "40",
        player: 2,
        right: 12,
        bottom: 19,
      },
    ],
  },

  wolvesAtOurHeels: {
    rules: [
      `- Starting on the Attacker's third turn, extend kill box by 2" at the beginning of each of the Attacker's turns.`,
      `- At the end of each scoring turn after points are scored, if a player has secured their own 40mm objective, they can add a token to their objective. If they do, their opponent may move that objective 3" towards the 50mm objective of the same color.`,
      `- After adding the third token to their objective a player scores 3 VP. If players add the third token on the same turn, no points are scored in this manner. This check occurs only once per game.`,
    ],
    objectives: [
      {
        type: "40",
        player: 1,
        left: 8,
        bottom: 20,
      },
      {
        type: "40",
        player: 2,
        left: 8,
        bottom: 15,
      },
      {
        type: "50",
        player: 1,
        left: 19,
        bottom: 24,
      },
      {
        type: "50",
        player: 2,
        left: 19,
        bottom: 20,
      },
      {
        type: "flag",
        player: 1,
        right: 12,
        bottom: 20,
      },
      {
        type: "flag",
        player: 2,
        right: 12,
        bottom: 20,
      },
    ],
  },

  pressurePoint: {
    rules: [`2 Victory Points scored for the Objective`],
    objectives: [
      {
        type: "flag",
        id: "flag2",
        player: 2,
        left: 6,
        bottom: 31,
      },
      {
        type: "flag",
        id: "flag4",
        player: 2,
        left: 12,
        bottom: 20,
      },
      {
        type: "flag",
        id: "flag3",
        player: 2,
        right: 12,
        bottom: 20,
      },
      {
        type: "flag",
        id: "flag1",
        player: 2,
        right: 6,
        bottom: 31,
      },
      {
        type: "50",
        player: 1,
        right: 23,
        bottom: 22,
      },
    ],
  },

  highStakes: {
    rules: [
      "At the start of the game place 5 countdown tokens on each piece of scenario terrain and the 50mm objective.",
      "+1VP for each secured scenario element with 0 countdown tokens.",
      `Starting on the Defender’s second turn, at the end of each player's turn before scoring if a player has secured the 50mm objective that player must choose that objective, or either objective terrain and remove 1d3 countdown tokens. The player cannot choose an objective or objective terrain that has 0 count down tokens.`,
      `If no player secures the 50mm, instead roll a d3:`,
      `1: Remove 1 countdown token from the Defender's objective terrain`,
      `2: Remove 1 countdown token from the Attacker's objective terrain`,
      `3: Remove 1 countdown token from the 50mm objective objective terrain`,
      `If an objective reaches 0 count down tokens, models within the objective terrain, or 3” of the objective or impassible objective terrain, suffer a POW14 magical blast damage roll. Then continue onto scoring.`,
    ],
    objectives: [
      {
        type: "40",
        player: 1,
        left: 14,
        bottom: 18,
      },
      {
        type: "flag",
        player: 1,
        right: 8,
        bottom: 20,
      },
      {
        type: "40",
        player: 2,
        left: 14,
        bottom: 17,
      },
      {
        type: "50",
        player: 2,
        left: 23,
        bottom: 22,
      },
      {
        type: "flag",
        player: 2,
        right: 8,
        bottom: 23,
      },
    ],
  },

  faultLine: {
    rules: [
      "+1 VP scored for a player securing two of their own objectives.",
      "+1 VP scored for a player securing all three of their own objectives.",
    ],
    objectives: [
      {
        type: "40",
        id: "401",
        player: 1,
        left: 8,
        bottom: 15,
      },
      {
        type: "50",
        player: 1,
        left: 23,
        bottom: 20,
      },
      {
        type: "40",
        id: "402",
        player: 1,
        right: 8,
        bottom: 25,
      },
      {
        type: "40",
        id: "401",
        player: 2,
        left: 8,
        bottom: 15,
      },
      {
        type: "50",
        player: 2,
        left: 23,
        bottom: 20,
      },
      {
        type: "40",
        id: "402",
        player: 2,
        right: 8,
        bottom: 25,
      },
    ],
  },

  payload: {
    rules: [
      `- After scoring, players may move each secured 50mm Objective up to 3+1", per other secured 40/50mm Objectives, towards their opponent’s Objective Terrain.`,
      `- After moving their 50mm Objective at the end of their turn, that player may move one friendly Cohort model 5" directly towards it.`,
      `- When a 50mm Objective ends within the area of the opponent’s Objective Terrain (if being within the terrain is impossible, within 3" of the terrain), score 3 VP and remove the 50mm Objective.`,
    ],
    objectives: [
      {
        type: "flag",
        player: 1,
        left: 16,
        bottom: 19,
      },
      {
        type: "40",
        player: 1,
        right: 20,
        bottom: 20,
      },
      {
        type: "50",
        player: 1,
        right: 9,
        bottom: 16,
      },
      {
        type: "flag",
        player: 2,
        left: 16,
        bottom: 19,
      },
      {
        type: "40",
        player: 2,
        right: 20,
        bottom: 20,
      },
      {
        type: "50",
        player: 2,
        right: 9,
        bottom: 16,
      },
    ],
  },
};
